import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { VAIconRegistryService, plus, close } from "@va/core-library/icons";

@Component({
  selector: "app-edit-charts-li",
  templateUrl: "./edit-charts-li.component.html",
  styleUrls: ["./edit-charts-li.component.scss"],
})
export class EditChartsLiComponent implements OnInit {
  @Input() addColTableData: Array<any>;
  @Input() stdLineItems: Array<any>;
  @Input() tickers: Array<string>;
  @Input() max: number;
  @Input() maxHeight: string;
  @Input() selectedPeriod: any;
  @Input() modalVisible: boolean;
  @Input() lineItemInputId = "chartsLiModalLineItemInput";
  @Input() disabled = false;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Output() onLiUpdate = new EventEmitter();
  watchlisNameInput = "";
  selectedTickers: Array<any> = [];
  recentlyVisited: Array<any> = [];
  rightHeader: string;
  modalData: Array<any> = [];
  legacyUrl = `${window.caUrl}/app`;
  visible: boolean;
  selectedMenuItem = "";
  lineItems: Array<any> = [];
  allItems: Array<any> = [];
  isLoading = false;
  selectedId = [];

  constructor(private iconRegistryService: VAIconRegistryService) {
    this.iconRegistryService.registerIcons([plus, close]);
  }

  ngOnInit() {
    this.rightHeader = `Selected Line Items(up to ${this.max}):`;
    //if (this.userTabId) {
    this.selectedMenuItem =
      this.stdLineItems &&
      this.stdLineItems[0] &&
      this.stdLineItems[0].tab_full_name;
    // this.recentlyVisited = res.data[0].tab_sli_data;}
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.addColTableData &&
      changes.addColTableData.currentValue !==
        changes.addColTableData.previousValue
    ) {
      this.modalData = [...this.addColTableData];
    }
    if (
      changes.stdLineItems &&
      changes.stdLineItems.currentValue !==
        changes.stdLineItems.previousValue &&
      changes.stdLineItems.currentValue.length
    ) {
      this.selectedMenuItem =
        this.stdLineItems[0] && this.stdLineItems[0].tab_full_name;
      // this.recentlyVisited = res.data[0].tab_sli_data;
      this.lineItems = [];
      for (let i = 0; i < this.stdLineItems.length; i++) {
        const items = Object.assign({}, this.stdLineItems[i]);
        this.stdLineItems[i].tab_sli_data.map((el, index) => {
          let lineItem = {};
          const addedColData = this.modalData.find((obj) => {
            if (obj.sli_id === el.sli_id) {
              obj["line_count"] = el.line_count
                ? `${el.line_count.toString()}`
                : null;
            }
            return obj.uniquesliid === el.uniquesliid;
          });
          if (addedColData) {
            addedColData.isSelected = true;
            items.tab_sli_data[index] = addedColData;
            const value = addedColData.sli_id || addedColData.uniquesliid;
            this.selectedId = this.selectedId.concat(value);
          } else {
            lineItem = {
              name: el.name,
              period: this.selectedPeriod
                ? this.selectedPeriod
                : [`CY-${new Date().getFullYear()}`],
              sli_comps_id: 0,
              sli_id: el.sli_id,
              uniquesliid: el.uniquesliid,
              source: "vaactuals.consensus",
              isSelected: false,
              line_count: el.line_count ? `${el.line_count.toString()}` : null,
            };
            items.tab_sli_data[index] = lineItem;
          }
          // let obj = Object.assign({}, el);
          return el;
        });
        this.lineItems.push(items);
        //this.recentlyVisited[i]["isSelected"] = false;
      }
      this.recentlyVisited = this.lineItems[0].tab_sli_data;
    }
  }

  addSearchedTicker(tickerInfo): void {
    const company = {};
    company["ticker"] = tickerInfo.ticker;
    company["name"] = tickerInfo.full_name;
    company["isSelected"] = true;
    const tickerExist = this.modalData.filter((data) => {
      return data.ticker === tickerInfo.ticker;
    });
    if (tickerExist.length === 0) {
      this.modalData.push(company);
      this.onLiUpdate.emit(this.modalData);
    }
  }

  addLi(params) {
    let tickerExist = [];
    if (params[2] !== "onscreen") {
      tickerExist = this.modalData.filter((data) => {
        return data.uniquesliid === params[0].uniquesliid;
      });
    }

    if (tickerExist.length === 0) {
      const selectedId = this.selectedId.concat(params[0].uniquesliid) || [];
      this.selectedId = selectedId;
      if (params[1]) {
        for (let i = 0; i < this.lineItems.length; i++) {
          this.lineItems[i].tab_sli_data.map((el) => {
            if (params[0].uniquesliid === el.uniquesliid) {
              el.isSelected = true;
            }
            return el;
          });
        }
      }
      params[0].isSelected = true;
      // const addedLIObj = {
      //   name: params[0].name,
      //   period: "CY-2020",
      //   sli_comps_id: params[0].sli_comps_id || 0,
      //   sli_id: params[0].sli_id,
      //   source: 'Concensus',
      //   isSelected: params[0].isSelected
      // }
      if (params[2] && params[2] === "onscreen") {
        this.modalData = [];
      }
      this.modalData.push(params[0]);
      this.onLiUpdate.emit(this.modalData);
    }
  }

  onLiSelect(e, d) {
    this.selectedMenuItem = d.tab_full_name;
    this.recentlyVisited = d.tab_sli_data;
  }

  onMenuVisibleChange(visible) {
    this.visible = visible;
  }

  onLineitemChange(ev) {
    const data = { ...ev };
    data.name = ev.label;
    let lineItem = {};
    lineItem = {
      name: data.label,
      period: this.selectedPeriod
        ? this.selectedPeriod
        : [`CY-${new Date().getFullYear()}`],
      sli_comps_id: 0,
      uniquesliid: data.id,
      source: "vaactuals.consensus",
      isSelected: true,
      line_count: data.line_count ? `${data.line_count.toString()}` : null,
    };
    let addedColData = [];
    let matched = false;
    for (let i = 0; i < this.lineItems.length; i++) {
      addedColData = this.lineItems[i].tab_sli_data.filter((obj) => {
        if (obj.uniquesliid === data.id) {
          obj.isSelected = true;
          matched = true;
        }
        return obj.uniquesliid === data.id;
      });
      if (matched) {
        break;
      }
    }

    if (addedColData.length > 0) {
      this.addLi([lineItem, true]);
    }
  }

  removeLi(company) {
    this.selectedId = this.selectedId.filter(
      (item) => item !== company.uniquesliid,
    );

    // if(company.sli_comps_id){
    for (let i = 0; i < this.lineItems.length; i++) {
      this.lineItems[i].tab_sli_data.map((el) => {
        if (company.uniquesliid === el.uniquesliid) {
          el.isSelected = false;
        }
        return el;
      });
    }
    //}
    // else{
    //   company.isSelected = false;
    // }
    //company.isSelected = false;

    const index = this.modalData.indexOf(company);
    this.modalData.splice(index, 1);
    this.onLiUpdate.emit(this.modalData);
  }

  addAll() {
    const len = this.recentlyVisited.length;
    for (let i = 0; i < len; i++) {
      this.addLi([this.recentlyVisited[i], false]);
    }
    this.onLiUpdate.emit(this.modalData);
  }

  removeAll() {
    this.modalData = [];
    this.onLiUpdate.emit(this.modalData);
    for (let i = 0; i < this.lineItems.length; i++) {
      this.lineItems[i].tab_sli_data.map((el) => {
        // let obj = Object.assign({}, el);
        el.isSelected = false;
        return el;
      });
    }
    this.selectedId = [];
  }

  updateLineitems() {
    this.onLiUpdate.emit(this.modalData);
  }

  onCancelModal() {
    this.selectedMenuItem = this.stdLineItems.length
      ? this.stdLineItems[0].tab_full_name
      : "";
    this.modalData = [...this.addColTableData];
    this.lineItems = [];
    for (let i = 0; i < this.stdLineItems.length; i++) {
      const items = Object.assign({}, this.stdLineItems[i]);
      this.stdLineItems[i].tab_sli_data.map((el, index) => {
        let lineItem = {};
        const addedColData = this.modalData.find((obj) => {
          if (obj.sli_id === el.sli_id) {
            obj["line_count"] = el.line_count
              ? `${el.line_count.toString()}`
              : null;
          }
          return obj.uniquesliid === el.uniquesliid;
        });
        if (addedColData) {
          addedColData.isSelected = true;
          items.tab_sli_data[index] = addedColData;
        } else {
          lineItem = {
            name: el.name,
            period: this.selectedPeriod
              ? this.selectedPeriod
              : [`CY-${new Date().getFullYear()}`],
            sli_comps_id: 0,
            sli_id: el.sli_id,
            uniquesliid: el.uniquesliid,
            source: "vaactuals.consensus",
            isSelected: false,
            line_count: el.line_count ? `${el.line_count.toString()}` : null,
          };
          items.tab_sli_data[index] = lineItem;
        }
        return el;
      });
      this.lineItems.push(items);
    }
    this.recentlyVisited = this.lineItems[0].tab_sli_data;
  }
}
